/**
 * @param {string} nameValue
 * @returns
 */

export function validateFullName(nameValue) {
  return /[A-z]* [A-z]* ?[A-z]?/.test(nameValue)
}
